(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-rich-text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const bundleWrappers = document.querySelectorAll(
      '.bundle-wrapper[data-bundle-block-id]'
    );

    if (!bundleWrappers.length) return;

    bundleWrappers.forEach(function (root) {
      const variantTriggers = root.querySelectorAll('.bundle-variant__trigger');
      const variantOptions = root.querySelectorAll('.bundle-variant__option');
      const qtyWrappers = root.querySelectorAll('.bundle-qty');
      const qtyDisplays = root.querySelectorAll('.bundle-qty-display');
      const submitBtn = root.querySelector('.bundle-submit-btn');
      const subscriptionGroups = root.querySelectorAll('[data-bundle-subscription]');

      if (!variantTriggers.length || !submitBtn) return;

      const baseLabel =
        submitBtn.getAttribute('data-label') || submitBtn.textContent;

      function formatMoney(cents) {
        const dollars = (cents / 100).toFixed(2);
        return '$' + dollars;
      }

      function clampQuantity(value) {
        if (value === null || value === undefined || isNaN(value) || value < 0) return 0;
        return value;
      }

      function getQuantityForIndex(index) {
        const hiddenQty = root.querySelector(
          '.hidden-quantity[data-index="' + index + '"]'
        );

        if (!hiddenQty) return 0;

        const value = parseInt(hiddenQty.value, 10);
        const clamped = clampQuantity(isNaN(value) ? 0 : value);

        if (clamped !== value) {
          hiddenQty.value = clamped;
        }

        return clamped;
      }


      function setQuantityForIndex(index, value) {
        const hiddenQty = root.querySelector(
          '.hidden-quantity[data-index="' + index + '"]'
        );
        const display = root.querySelector(
          '.bundle-qty-display[data-index="' + index + '"]'
        );

        if (!hiddenQty) return;

        const clamped = clampQuantity(parseInt(value, 10) || 0);
        hiddenQty.value = clamped;

        if (display) {
          display.textContent = clamped;
        }
      }

      function getSellingPlanForIndex(index) {
        const hiddenPlan = root.querySelector(
          '.hidden-selling-plan[data-index="' + index + '"]'
        );
        if (!hiddenPlan) return '';
        return hiddenPlan.value || '';
      }

      function setSellingPlanForIndex(index, value) {
        const hiddenPlan = root.querySelector(
          '.hidden-selling-plan[data-index="' + index + '"]'
        );
        if (!hiddenPlan) return;
        hiddenPlan.value = value || '';
      }

      function computeAdjustedPrice(basePrice, planRadio) {
        if (!planRadio) return basePrice;

        const type = planRadio.getAttribute('data-plan-adjustment-type');
        const valueRaw = planRadio.getAttribute('data-plan-adjustment-value');
        const value = parseFloat(valueRaw || '0');

        if (!type || !value) {
          return basePrice;
        }

        if (type === 'percentage') {
          const discount = basePrice * (value / 100);
          return Math.max(0, Math.round(basePrice - discount));
        }

        if (type === 'fixed_amount') {
          const discountCents = Math.round(value * 100);
          return Math.max(0, basePrice - discountCents);
        }

        if (type === 'price') {
          const finalCents = Math.round(value * 100);
          return Math.max(0, finalCents);
        }

        return basePrice;
      }

      function getSelectedVariantOption(index) {
        return root.querySelector(
          '.bundle-variant__option.is-active[data-index="' + index + '"]'
        );
      }

      function getUnitPriceForIndex(index) {
        const opt = getSelectedVariantOption(index);
        if (!opt) return 0;

        const baseAttr = opt.getAttribute('data-price') || '0';
        const basePrice = parseInt(baseAttr, 10) || 0;

        const sellingPlanId = getSellingPlanForIndex(index);
        if (!sellingPlanId) {
          return basePrice;
        }

        const planRadio = root.querySelector(
          '[data-bundle-selling-plan][data-index="' + index + '"][value="' + sellingPlanId + '"]'
        );

        return computeAdjustedPrice(basePrice, planRadio);
      }

      function updateLinePrice(index) {
        const priceSpan = root.querySelector(
          '.bundle-product__price[data-index="' + index + '"]'
        );

        if (!priceSpan) return;

        const unitPrice = getUnitPriceForIndex(index);
        const qty = getQuantityForIndex(index);
        const lineTotal = unitPrice * qty;

        priceSpan.textContent = formatMoney(lineTotal) + ' CAD ';
      }

      function recalcTotal() {
        let total = 0;

        variantTriggers.forEach(function (trigger) {
          const idx = trigger.dataset.index;
          const unitPrice = getUnitPriceForIndex(idx);
          const qty = getQuantityForIndex(idx);
          total += unitPrice * qty;
        });

        submitBtn.textContent = baseLabel + ' · ' + formatMoney(total) + ' CAD ';
      }

      function closeAllVariantLists(exceptIndex) {
        const lists = root.querySelectorAll('.bundle-variant__list');
        const triggers = root.querySelectorAll('.bundle-variant__trigger');
        lists.forEach(function (list) {
          const idx = list.getAttribute('data-index');
          if (exceptIndex !== undefined && idx === String(exceptIndex)) return;
          list.classList.add('is-hidden');
        });
        triggers.forEach(function (trigger) {
          const idx = trigger.getAttribute('data-index');
          if (exceptIndex !== undefined && idx === String(exceptIndex)) return;
          trigger.setAttribute('aria-expanded', 'false');
        });
      }

      variantTriggers.forEach(function (trigger) {
        const idx = trigger.dataset.index;
        const list = root.querySelector(
          '.bundle-variant__list[data-index="' + idx + '"]'
        );

        if (!list) return;

        trigger.addEventListener('click', function () {
          const isOpen = list.classList.contains('is-hidden') === false;
          if (isOpen) {
            list.classList.add('is-hidden');
            trigger.setAttribute('aria-expanded', 'false');
          } else {
            closeAllVariantLists(idx);
            list.classList.remove('is-hidden');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      });

      variantOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          const idx = option.dataset.index;
          const variantId = option.getAttribute('data-variant-id');
          const priceAttr = option.getAttribute('data-price') || '0';

          const trigger = root.querySelector(
            '.bundle-variant__trigger[data-index="' + idx + '"]'
          );
          const list = root.querySelector(
            '.bundle-variant__list[data-index="' + idx + '"]'
          );
          const hiddenVariantInput = root.querySelector(
            '.hidden-variant-id[data-index="' + idx + '"]'
          );

          if (trigger) {
            trigger.textContent = option.textContent.trim();
          }

          const siblings = root.querySelectorAll(
            '.bundle-variant__option[data-index="' + idx + '"]'
          );
          siblings.forEach(function (s) {
            s.classList.remove('is-active');
            s.setAttribute('aria-selected', 'false');
          });
          option.classList.add('is-active');
          option.setAttribute('aria-selected', 'true');

          if (hiddenVariantInput) {
            hiddenVariantInput.value = variantId;
          }

          if (list && trigger) {
            list.classList.add('is-hidden');
            trigger.setAttribute('aria-expanded', 'false');
          }

          updateLinePrice(idx);
          recalcTotal();
        });
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) {
          closeAllVariantLists();
        }
      });

      qtyWrappers.forEach(function (wrapper) {
        const idx = wrapper.dataset.index;
        const minusBtn = wrapper.querySelector('.bundle-qty__btn--minus');
        const plusBtn = wrapper.querySelector('.bundle-qty__btn--plus');

        if (minusBtn) {
          minusBtn.addEventListener('click', function (event) {
            const current = getQuantityForIndex(idx);
            const next = Math.max(0, current - 1);
            setQuantityForIndex(idx, next);
            updateLinePrice(idx);
            recalcTotal();
            event.currentTarget.blur();
          });
        }

        if (plusBtn) {
          plusBtn.addEventListener('click', function (event) {
            const current = getQuantityForIndex(idx);
            const next = current + 1;
            setQuantityForIndex(idx, next);
            updateLinePrice(idx);
            recalcTotal();
            event.currentTarget.blur();
          });
        }
      });

      qtyDisplays.forEach(function (display) {
        const idx = display.dataset.index;
        const qty = getQuantityForIndex(idx);
        display.textContent = qty;
      });

      subscriptionGroups.forEach(function (group) {
        const index = group.dataset.index;
        const groupToggles = group.querySelectorAll('[data-bundle-selling-plan-toggle]');
        const plansContainers = group.querySelectorAll('[data-bundle-subscription-plans]');
        const plansRadios = group.querySelectorAll('[data-bundle-selling-plan]');

        (function initSubscriptionVisibility() {
          const oneTimeToggle = group.querySelector(
            '[data-bundle-selling-plan-toggle][data-bundle-selling-plan-group=""]'
          );
          const checkedGroupToggle = group.querySelector(
            '[data-bundle-selling-plan-toggle]:checked'
          );

          if ((oneTimeToggle && oneTimeToggle.checked) || !checkedGroupToggle) {
            plansContainers.forEach(function (container) {
              container.classList.add('hide');
            });
          } else {
            const activeGroupId = checkedGroupToggle.getAttribute('data-bundle-selling-plan-group');
            plansContainers.forEach(function (container) {
              const containerGroupId = container.getAttribute('data-bundle-subscription-plans');
              if (containerGroupId === activeGroupId) {
                container.classList.remove('hide');
              } else {
                container.classList.add('hide');
              }
            });
          }
        })();

        groupToggles.forEach(function (toggle) {
          toggle.addEventListener('change', function () {
            const sellingPlanGroupId = toggle.getAttribute('data-bundle-selling-plan-group');
            const defaultPlanId = toggle.getAttribute('data-bundle-selling-plan-id') || '';

            plansContainers.forEach(function (container) {
              const containerGroupId = container.getAttribute('data-bundle-subscription-plans');
              if (containerGroupId === sellingPlanGroupId && sellingPlanGroupId !== '') {
                container.classList.remove('hide');
              } else {
                container.classList.add('hide');
              }
            });

            if (!sellingPlanGroupId) {
              setSellingPlanForIndex(index, '');
              updateLinePrice(index);
              recalcTotal();
              return;
            }

            let selectedPlanId = '';

            plansRadios.forEach(function (radio) {
              if (
                radio.getAttribute('data-bundle-selling-plan-group') === sellingPlanGroupId &&
                radio.checked
              ) {
                selectedPlanId = radio.value;
              }
            });

            if (!selectedPlanId) {
              selectedPlanId = defaultPlanId;
              plansRadios.forEach(function (radio) {
                if (radio.value === defaultPlanId) {
                  radio.checked = true;
                }
              });
            }

            setSellingPlanForIndex(index, selectedPlanId);
            updateLinePrice(index);
            recalcTotal();
          });
        });

        plansRadios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            if (!radio.checked) return;
            const planId = radio.value;
            setSellingPlanForIndex(index, planId);
            updateLinePrice(index);
            recalcTotal();
          });
        });
      });

      variantTriggers.forEach(function (trigger) {
        const idx = trigger.dataset.index;
        updateLinePrice(idx);
      });

      recalcTotal();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
